export default __webpack_public_path__ + "static/figure_woman-abbd232a2b128d3c1932e2eb200ad59d.png";